import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import moment from 'moment';

import { PromanDateTimeModule } from '../datepicker/proman-date-time.module';

import { RangeValidator } from '../validators/range.validator';
import { NumberValidator } from '../validators/number.validator';

import { PromanFile } from '../interfaces/entity-interfaces';
import { EntityItemFieldConfig } from '../interfaces/object-interfaces';

import { PromanButtonComponent } from '../button';
import { PromanTextSimpleComponent } from '../text-simple';
import { DialogTitleComponent } from '../common-components/standalone/dialog-title.component';
import { DialogActionsComponent } from '../common-components/standalone/dialog-actions.component';

@Component({
    selector: 'pro-files-manager-restrictions-dialog',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        PromanDateTimeModule,
        MatDialogModule,

        DialogTitleComponent,
        DialogActionsComponent,
        PromanTextSimpleComponent,
      PromanButtonComponent,
    ],
    template: `
        <form #createForm="ngForm"
              [formGroup]="form"
              (ngSubmit)="confirm(form)">
            <pro-dialog-title [title]="'restrictions'"></pro-dialog-title>
            <div mat-dialog-content fxLayout="column">
                <div fxLayout="row">
                    <pro-text-simple [value]="file.accessibleTimes"
                                     [config]="{ label: 'times', required: false, type: 'number' }"
                                     [control]="timesControl"
                                     (onChange)="timesControl.setValue($event)"></pro-text-simple>
                    <pro-btn icon="times" theme="warn" (onClick)="resetField('times')"></pro-btn>
                </div>
                <div fxLayout="row">
                    <pro-datepicker [value]="file.accessibleUntil"
                                    [config]="{ label: 'date', min: datetimeNow }"
                                    (onChange)="untilControl.setValue($event)"></pro-datepicker>
                    <pro-btn icon="times" theme="warn" (onClick)="resetField('until')"></pro-btn>
                </div>
            </div>
            <pro-dialog-actions [variant]="'confirm'" [isCallbackDisabled]="!form.valid"></pro-dialog-actions>
        </form>
    `
})

export class PromanFilesManagerRestrictionsDialogComponent {
    parameters: EntityItemFieldConfig[];
    form: UntypedFormGroup;
    timesControl: UntypedFormControl;
    untilControl: UntypedFormControl;
    datetimeNow = moment().utc(true).format();

    file: PromanFile;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { file: PromanFile },
        public dialogRef: MatDialogRef<PromanFilesManagerRestrictionsDialogComponent>
    ) {
        this.file = { ...data.file };
        console.log(this.data);

        this.timesControl = new UntypedFormControl(parseInt(`${this.file.accessibleTimes}`), {
            validators: [NumberValidator],
            updateOn: 'change'
        });
        this.untilControl = new UntypedFormControl(this.file.accessibleUntil, {
            validators: [],
            updateOn: 'change'
        });
        this.form = new UntypedFormGroup({ times: this.timesControl, until: this.untilControl });
    }

    resetField(field: string) {
        switch (field) {
            case 'times':
                this.file.accessibleTimes = null;
                this.timesControl.reset(null);
                break;
            case 'until':
                this.file.accessibleUntil = null;
                this.untilControl.reset(null);
                break;
        }
    }

    confirm(createForm: UntypedFormGroup) {
        console.log(createForm.value);
        this.dialogRef.close(Object.assign({}, createForm.value));
    }

}
